<template>
  <div class="timer">
    <p>{{time}}</p>
  </div>
</template>

<script>
import request from '../requests';

export default {
  name: 'Timer',
  props: ['fieldId', 'fieldStatus', 'endTime'],
  data() {
    return { 
      now: Math.trunc((new Date()).getTime() / 1000),
      end: Math.trunc((new Date(this.endTime)).getTime() / 1000) || 0,
      updateInterval: null,
    }
  },
  beforeMount() {
    this.updateInterval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000);
    }, 1000);

    // console.log(this.fieldId, this.endTime)

  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
  },
  methods: {
    formatTime(t) {
      var s = `0${Math.trunc((t % 60))}`.slice(-2),
          m = `0${Math.trunc((t / 60) % 60)}`.slice(-2),
          h = `0${Math.trunc((t / 60 / 60) % 24)}`.slice(-2);
      return `${h}:${m}:${s}`;
    }
  },
  computed: {
    time: function() {
      if(this.end <= 0) { return 'N/A'}

      var t = this.end - this.now;

      // console.log(this.end, this.now, t)

      if(t <= 0) {
        this.$emit('zeroTime');
        this.end = Math.trunc((new Date(this.endTime)).getTime() / 1000) || 0;
        
        // console.log(this.fieldId, 'end', this.end)
        // console.log(this.fieldId, 'endTime', this.endTime)
        // console.log(this.fieldId, 't', t)


        // return this.fieldStatus != 2 ? 'N/A' : 'standby'
        return `<0  ${t}`
      }
      

      return this.formatTime(t)
    }
  },
  watch: {
    endTime(val) {
      this.end = Math.trunc((new Date(val)).getTime() / 1000);
    }
  }

}

/*
export default {
  name: 'Timer',
  props:['fieldId', 'fieldStatus'],
  data(){
      return {
        status: 0,
        now: Math.trunc((new Date()).getTime() / 1000),
        event: Math.trunc((new Date()).getTime() / 1000)
      }
  },
  beforeMount(){
    this.status = this.fieldStatus;
    var context = this;
    
    if(this.fieldStatus == 1){
      this.getClosestBooking();
    } else if (this.fieldStatus == 2) {
      this.getStandbyTime();
    }
    
    setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  methods:{
    getClosestBooking: function(){
      var context = this;
      request.getClosestBooking(this, this.fieldId, function(result){
        if(result.data){
          var d = new Date(result.data.end_time);
          context.event = d;
        } else {
          
          //On all lights on/off, this timeout needs to be here to allow for processing time for the bookings
          setTimeout(function(){
            request.getClosestBooking(context, context.fieldId, function(result){
              if(result.data){
                var d = new Date(result.data.end_time);
                context.event = d;
              }
            });
          }, 1000)
        }
      });
    },
    getStandbyTime: function(){
      var context = this;
      request.getStandbyTime(this, this.fieldId, function(result){
        if(result.data){
          var booking_end = new Date(result.data.end_time);
          booking_end.setMinutes(booking_end.getMinutes() + result.data.standby);
          var d = new Date(booking_end);
          context.event = d;
        }
      });
    },
    
  },
  computed: {
    time(){
      if((!this.hours && this.hours !== 0) || (!this.minutes && this.minutes !== 0) || (!this.seconds && this.seconds !== 0)){
        return 'N/A';
      }
      if(this.status == 0){
        return 'N/A';
      }
      
      if((this.hours <= 0) && (this.minutes <= 0) && (this.seconds <= 0)){
        this.getClosestBooking();
        return 'Processing..';
      }
      
      
      var h = this.hours < 10 ? `0${this.hours}` : this.hours;
      var m = this.minutes < 10 ? `0${this.minutes}` : this.minutes;
      var s = this.seconds < 10 ? `0${this.seconds}` : this.seconds;
      
      h = this.hours < 1 ? `00` : h;
      m = this.minutes < 1 ? `00` : m;
      s = this.seconds < 1 ? `00` : s;
      
      return `${h}:${m}:${s}`;
    },
    calculatedDate () {
      if(this.event){
        this.event = Math.trunc(Date.parse(this.event) / 1000)
      } else {
        this.event = new Date();
      }
      return this.event
    },
    seconds () {
      return (this.calculatedDate - this.now) % 60
    },
    minutes () {
      return Math.trunc((this.calculatedDate - this.now) / 60) % 60
    },
    hours () {
      return Math.trunc((this.calculatedDate - this.now) / 60 / 60) % 24
    },
  },
  watch: {
    fieldStatus: function(val){
      console.log('Status change for: ' + val);
      this.event = Math.trunc((new Date()).getTime() / 1000);
      if(val == 0){
        this.status = 0;
      } else if(val == 2){
        this.status = 2;
        this.getStandbyTime();
      } else {
        this.status = 1;
        this.getClosestBooking();
      }
    }
  }
}
*/
</script>


// WEBPACK FOOTER //
// Timer.vue?22ab8596